import React, { type FC, createContext, useContext, useEffect, useState } from 'react';

import { fetchMachineMotionConfigInfo } from '@src/Main/main';
import { type ConfigInfo } from '@src/ConfigInfo';

interface ConfigInfoContextData {
  configInfo?: ConfigInfo | undefined
  configInfoFetched: boolean
  fetchConfig: () => void
}

const ConfigInfoContext = createContext<ConfigInfoContextData>({
  configInfoFetched: false,
  fetchConfig: () => {},
});

export const useConfigInfo = (): ConfigInfoContextData => useContext(ConfigInfoContext);

export const ConfigInfoProvider: FC = ({ children }) => {
  const [configInfo, setConfigInfo] = useState();
  const [configInfoFetched, setConfigInfoFetched] = useState(false);

  function fetchConfig (): void {
    fetchMachineMotionConfigInfo((configs) => {
      setConfigInfo(configs);
      setConfigInfoFetched(true);
    });
  }

  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <ConfigInfoContext.Provider value={{ configInfo, configInfoFetched, fetchConfig }}>
      {children}
    </ConfigInfoContext.Provider>
  );
};
